import axios from './axios';

interface LoginResponse {
  access_token: string;
  token_type: string;
}

interface LoginData {
  username: string;
  password: string;
}

export const authApi = {
  login: async (data: LoginData): Promise<LoginResponse> => {
    const formData = new FormData();
    formData.append('username', data.username);
    formData.append('password', data.password);

    const response = await axios.post<LoginResponse>('/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },
  
  getUser: async () => {
    // Use the correct endpoint - /auth/me instead of /users/me
    const response = await axios.get('/auth/me');
    return response.data;
  },
  
  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await axios.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  }
};
